import * as React from "react";
import * as L from 'leaflet';
import {marker, MarkerCluster} from 'leaflet';
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
} from 'react-leaflet';
import * as MarkerIcon from '../../assets/img/marker-icon.png';
import * as MarkerShadow from '../../assets/img/marker-shadow.png';
import MarkerClusterGroup from 'react-leaflet-cluster';
import {GeoProps} from "../services/SearchService";
import {latLongType} from "./App";
import { v4 as uuid } from 'uuid';
import CurrentPositionMarker from "./CurrentPositionMarker";
import { GestureHandling } from 'leaflet-gesture-handling';

interface Props {
    results: any | undefined;
    geo: GeoProps;
    onChangeGeo: (latlng: latLongType) => void;
}


const MapView:React.FC<Props> = (props) =>  {
    const additionalOptions = {
        gestureHandling: true,
        duration: 5_000
    };

    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

    const icon = L.icon({
        iconSize: [48, 48],
        iconAnchor: [24, 40],
        popupAnchor: [0, -40],
        shadowSize: [48, 48],
        shadowAnchor: [24, 40],
        // iconUrl: "https://unpkg.com/leaflet@1.9.1/dist/images/marker-icon.png",
        // @ts-ignore
        iconUrl: MarkerIcon,
        // @ts-ignore
        shadowUrl: MarkerShadow,
    });

    const markers = () => {
        if (props.results === undefined || props.results.length === 0){
            return ;
        }
        return props.results.map((result: any) => {
            if (result.geo === undefined){
                return;
            }
            const lat = result.geo[0];
            const long = result.geo[1];
            const isNotUndefined = lat !== undefined && long !== undefined;
            const isNotNull = lat !== null && long !== null;
            if (isNotUndefined && isNotNull){
                return <Marker
                        position={[lat, long]}
                        key={result.shapeId}
                        icon={icon}
                    >
                    <Popup >
                        <div className={'map-popup'}>
                            <h2 className={'h3 hyphenate'}>
                                <strong>{result.category}</strong>
                                <span>{result.location}</span>
                            </h2>
                            <a href={result.url}>
                                zu den weiteren Informationen
                            </a>
                        </div>
                    </Popup>
                </Marker>
            }else {
                return null
            }
        })
    }
    const createClusterCustomIcon = function (cluster: MarkerCluster) {
        return L.divIcon({
            html: `<span>${cluster.getChildCount()}</span>`,
            className: "custom-marker-cluster",
            iconSize: L.point(40, 40, true),
        });
    };

    const getText = () => {
        if (props.geo.lat !== undefined && props.geo.lng !== undefined){
            return `Es werden nun alle Kleindenkmale im Umkreis von ${props.geo.distance}km angezeigt.`
        }
        return "Ermitteln Sie Ihren Standort über den Umkreis Filter oder klicken Sie auf die Karte um einen Marker zu setzen."
    }

    return (<div className={'map-view'}>
            <div className={`map-info ${props.geo.lat !== undefined && props.geo.lng !== undefined ? 'has-geo' : ''}`}>
                { getText() }
            </div>
            <MapContainer
                center={[48.395858, 9.380775]}
                zoom={10}
                style={{height: "600px"}}
                { ...additionalOptions }
            >

                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <MarkerClusterGroup
                    iconCreateFunction={createClusterCustomIcon}
                    key={uuid()}
                    maxClusterRadius={100}
                    spiderfyOnMaxZoom={true}
                    polygonOptions={{
                        fillColor: "#000",
                        color: "#f00800",
                        weight: 5,
                        opacity: 1,
                        fillOpacity: 0.8
                    }}
                    showCoverageOnHover={false}
                >
                    {markers()}
                </MarkerClusterGroup>

                <CurrentPositionMarker geo={props.geo} onChangeGeo={props.onChangeGeo.bind(this)}  />
            </MapContainer>
        </div>
    )
};

export default MapView;
